module.exports = __webpack_public_path__ + "img/lighting_banner.9d5ce302.png";